import { useTranslationHook } from '../../hooks/UseTranslationHook';

const TutorialsData = () => {
  const {
    usersString,
    techsString,
    clientsString,
    visitsString,
    equipsString,
    assetsString,
  } = useTranslationHook();

  return [
    {
      id: 1,
      title: 'General',
      description: '',
      icon: <></>,
    },
    {
      id: 2,
      title: usersString,
      description: '',
      icon: <></>,
      path: '',
    },
    {
      id: 3,
      title: techsString,
      description: '',
      icon: <></>,
      path: '',
    },
    {
      id: 4,
      title: 'Geoloc Techs',
      description: '',
      icon: <></>,
      path: '',
    },
    {
      id: 5,
      title: clientsString,
      description: '',
      icon: <></>,
      path: '',
    },
    {
      id: 6,
      title: 'Info Plaza',
      description: '',
      icon: <></>,
      path: '',
      // CHECK THIS CASE
    },
    {
      id: 7,
      title: visitsString,
      description: '',
      icon: <></>,
      path: '',
    },
    {
      id: 8,
      title: 'Control Servicios',
      description: '',
      icon: <></>,
      path: '',
    },
    {
      id: 9,
      title: 'Tipos de servicios',
      description: '',
      icon: <></>,
      path: '',
    },
    {
      id: 10,
      title: equipsString,
      description: '',
      icon: <></>,
      path: '',
    },
    {
      id: 11,
      title: assetsString,
      description: '',
      icon: <></>,
      path: '',
    },
    {
      id: 12,
      title: 'Agenda',
      description: '',
      icon: <></>,
      path: '',
    },
    {
      id: 13,
      title: 'Mapa',
      description: '',
      icon: <></>,
      path: '',
    },
    {
      id: 14,
      title: 'Cuestionarios',
      description: '',
      icon: <></>,
      path: '',
    },
  ];
};

export default TutorialsData;
